import { useMemo } from 'react'

import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'

import PaymentScreen from '@/modules/checkout/screens/payment'
import { env } from '@/shared/env'
import { useLinkId } from '@/shared/hooks/use-link-id'
import { needRecaptcha } from '@/shared/utils/recaptcha'

const PaymentPage = () => {
  const { t } = useTranslation()
  const title = useMemo<string>(() => t('Pagamento'), [t])
  const id = useLinkId()

  const recaptchaSrc = useMemo(() => {
    if (!env.VITE_RECAPTCHA_SITE_KEY || !needRecaptcha()) {
      return undefined
    }

    return `https://www.google.com/recaptcha/enterprise.js?render=${env.VITE_RECAPTCHA_SITE_KEY}`
  }, [])

  return (
    <>
      {/* O script vai como child: o prop `script` do Helmet e ignorado a
          partir da v3 quando roda em React 19, e o recaptcha simplesmente
          nao era carregado. */}
      <Helmet>
        <title>{title}</title>
        {recaptchaSrc ? <script src={recaptchaSrc} async /> : null}
      </Helmet>
      <PaymentScreen id={id} title={title} />
    </>
  )
}

export default PaymentPage
